import React, { useContext } from 'react';
import './RocketContinue.css';
import { RocketContext } from '../../services/context/RocketContext.js';
import PropTypes from 'prop-types';
import { defaultAnalyticsVariables, pagePrefix, events } from '../../services/Constants/Analytics.js';

/**
 * @param {object} props - the props of the component
 * @param {boolean} props.isFailure - whether successful or not
 * @returns {JSX.Element} SuccessContinue Component
 */
export default function RocketContinue({ isFailure }) {
  const { onContinue, journeyType } = useContext(RocketContext);

  const handleClick = () => {
    if (journeyType === 'subscription') {
      // Fire analytics only for subscription
      window.utag?.link({
        ...defaultAnalyticsVariables,
        event_name: [events.interaction],
        page_name: `${pagePrefix}: subscription activated`,
        link_id: `${pagePrefix}: subscription activated: continue shopping`,
      });
    }

    onContinue();
  };

  return (
    <section className='success-continue v-container'>
      <button
        className='tertiary-button'
        onClick={ handleClick }
      >{isFailure ? 'OK' : 'Continue shopping'}</button>
    </section>
  );
}

RocketContinue.propTypes = { isFailure: PropTypes.bool };
